import {Button} from '@wandb/weave/components/Button';
import React from 'react';

import {StyledButtonWrapper} from './PanelActions.style';
import {usePanelContext} from './PanelContextProvider';
import {useOpenPanelEditor} from './PanelHeader/useOpenPanelEditor';

export const PanelFullScreenButton = () => {
  const openPanelEditor = useOpenPanelEditor();
  const {trackPanelControls} = usePanelContext();

  return (
    <StyledButtonWrapper title="View fullscreen" className="panel-action">
      <Button
        className="text-moon-600"
        icon="full-screen-mode-expand"
        variant="ghost"
        aria-label="View full screen"
        size="small"
        tooltip={'View full screen'}
        tooltipProps={{className: 'py-8 px-12'}}
        onClick={() => {
          openPanelEditor();
          trackPanelControls({
            action: 'View full screen clicked',
          });
        }}
      />
    </StyledButtonWrapper>
  );
};
